import { useCountdown } from './useCountdown';

export const useGuestTimer = (onTimerComplete: () => void, expirationTime: number | null) => {
  const remainingSeconds = useCountdown(onTimerComplete, expirationTime ?? 0);

  return { remainingSeconds: expirationTime === null ? null : remainingSeconds };
};
